/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teary_Funny_Jellyfish_ClipInputs */

const fr_teary_funny_jellyfish_clip = /** @type {(inputs: Teary_Funny_Jellyfish_ClipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

/**

* @param {Teary_Funny_Jellyfish_ClipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teary_funny_jellyfish_clip = /** @type {((inputs?: Teary_Funny_Jellyfish_ClipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teary_Funny_Jellyfish_ClipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teary_funny_jellyfish_clip(inputs)
});